import axios from 'axios'

export const uploadFile = async (file, timestamp, atlasFileType, token) => {
    try {
        console.log('Upload starting for file:', file.name || 'unnamed file')

        const formData = new FormData()

        // Check if file is a File/Blob object or has a file property
        if (file instanceof File || file instanceof Blob) {
            formData.append('userfile', file)
        } else if (file.file) {
            formData.append('userfile', file.file)
        } else if (file.link instanceof File || file.link instanceof Blob) {
            // If link is a File/Blob (which it shouldn't be based on naming, but check anyway)
            formData.append('userfile', file.link)
        } else {
            // If we get here, we don't have a valid file to upload
            console.error('Invalid file object for upload:', file)
            throw new Error('Invalid file object - no file data found')
        }

        // Add metadata as separate form fields
        if (file.name) formData.append('fileName', file.name)
        if (file.type) formData.append('fileType', file.type)
        if (file.size) formData.append('fileSize', file.size)

        console.log('FormData prepared, sending to /api/aws/upload')

        const response = await axios.post('/api/aws/upload', formData, {
            headers: {
                timestamp: timestamp,
                Authorization: `Bearer ${token}`,
                atlasFiletype: atlasFileType,
                'X-CSRF-Token': getCookie('XSRF-TOKEN'),
                // Don't set Content-Type here - axios will set it automatically with boundary
            },
            // Add progress tracking
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                console.log(`Upload progress: ${percentCompleted}%`)
            },
        })

        console.log('File upload success:', response.data)
        return response.data
    } catch (error) {
        console.error('File upload error:', error)
        console.error('Error details:', error.response ? error.response.data : 'No response data')
        throw error
    }
}

function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
}
